export const RIDES_QUERY_PARAMS = {
  page: 1,
  perPage: 4,
};
